import React, { useMemo } from 'react';
import { DateTime } from 'luxon';

import { useReauthSharedWorkerProvider } from '../../../../workers/SharedWorkerProvider';
import AboutToExpireModal from './AboutToExpireModal';

export default function AboutToExpireModalHost(): JSX.Element {
	const {
		expirationTime,
		showModal,
		initializeExtendSession,
		dispatchCloseSession,
	} = useReauthSharedWorkerProvider();

	const expiryDate = useMemo(
		() => (expirationTime ? DateTime.fromISO(expirationTime) : null),
		[expirationTime],
	);

	if (!expiryDate || !expiryDate.isValid) {
		return <></>;
	}

	return (
		<AboutToExpireModal
			open={showModal}
			expiryDate={expiryDate}
			onExtend={initializeExtendSession}
			onLogout={dispatchCloseSession}
		/>
	);
}
